<template>
  <div class="form-group">
    <label class="control-label w-100">
      <span>Seleccione Productor</span>
    </label>

    <el-autocomplete
      v-model="value"
      v-validate="modelValidations.producer"
      name="producer"
      :disabled="!canSearch"
      :debounce="500"
      :trigger-on-focus="false"
      :fetch-suggestions="querySearchAsync"
      placeholder="Seleccione Productor (*)"
      @select="onSelected"
    ></el-autocomplete>

    <small v-show="searchError !== ''" class="text-danger d-block">
      {{ searchError }}
    </small>

    <small v-show="producer.invalid" class="text-danger d-block">
      {{ getError('producer') }}
    </small>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Autocomplete, Select, Option } from 'element-ui';
import remoteAutocompleteMixin from '../../mixins/remoteAutocompleteMixin';

export default {
  components: {
    [Autocomplete.name]: Autocomplete,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [remoteAutocompleteMixin],
  props: {
    distributor: {
      type: Number,
      default: null,
    },

    filterByDistributor: {
      type: Boolean,
      default: true,
    },

    emptyCuitFilter: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      value: null,
      selected: null,
      producers: [],
      modelValidations: {
        producer: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['producer']),
    canSearch() {
      // si filtra por dist y el dist !== null pero puede listarlos -> puede buscar
      // si filtra por dist y el dist === null pero no puede listarlos -> puede buscar
      // si no filtra por dist -> puede buscar
      return (
        !this.filterByDistributor ||
        (this.filterByDistributor && this.$can('index', 'distributors') && this.distributor !== null) ||
        (!this.$can('index', 'distributors') && this.distributor === null)
      );
    },
  },

  methods: {
    selectOptions() {
      return this.producers;
    },

    fetchData(query) {
      this.producers = [];

      const params = { query, distributor_id: this.distributor };

      if (this.emptyCuitFilter !== null) {
        params['empty_cuit'] = this.emptyCuitFilter;
      }

      return this.$services
        .resource('producers')
        .search(params)
        .then((res) => res.data.data)
        .then((producers) => {
          this.checkResults(producers);
          this.producers = producers;
        });
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll();
    },

    onSelected(item) {
      this.selected = item.id;
      this.$emit('input', this.selected);
    },

    clearSelection() {
      this.selected = null;
      this.value = null;
    },
  },
};
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>
